(function () {
  function init() {
    var el = document.querySelector(".imd-celeb-slider");
    if (!el || el.classList.contains("imd-ready")) return;

    el.classList.add("imd-ready");

    if (typeof Swiper === "undefined") {
      console.error("Swiper not loaded");
      return;
    }

    new Swiper(el, {
      loop: true,
      slidesPerView: 4.2,
      speed: 3000,
      autoplay: {
        delay: 0,
        disableOnInteraction: true,
      },
      breakpoints: {
        250: { slidesPerView: 1 },
        600: { slidesPerView: 2 },
        850: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
      },
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);
})();